import { createContext, useContext, type ReactNode } from 'react';

type EntityRecord = Record<string, unknown>;

const ValidationEntityContext = createContext<EntityRecord | null>(null);

interface ValidationEntityProviderProps {
  entity: EntityRecord;
  children: ReactNode;
}

export const ValidationEntityProvider = ({
  entity,
  children,
}: ValidationEntityProviderProps) => {
  return (
    <ValidationEntityContext.Provider value={entity}>
      {children}
    </ValidationEntityContext.Provider>
  );
};

export const useValidationEntity = (): EntityRecord | null => {
  return useContext(ValidationEntityContext);
};
